import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { HelperService } from "./helper.service";
import { LogoutService } from "./logout.service";

@Injectable({
  providedIn: "root",
})
export class PostService {
  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private router: Router,
    private logoutService: LogoutService
  ) {}

  post(url: string, request: FormData): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Access-Control-Allow-Origin": "*",
      });
    }

    let post = this.http.post(url, request, {
      headers: headers,
    });

    return post.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }

  patch(url: string, request: {}): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Content-Type": "application/json",
      });
    }

    let patch = this.http.patch(url, request, {
      headers: headers,
    });

    return patch.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }
  delete(url: string, request: FormData): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Content-Type": "application/json",
      });
    }

    let del = this.http.delete(url, {
      headers: headers,
    });

    return del.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }
  get(url: string): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Access-Control-Allow-Origin": "*",
      });
    }

    let get = this.http.get(url, {
      headers: headers,
    });

    return get.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }

  postRequest(url: string, request: {}): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Access-Control-Allow-Origin": "*",
      });
    }

    let post = this.http.post(url, request, {
      headers: headers,
    });

    return post.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }

  getrequest(url: string): Observable<any> {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Access-Control-Allow-Origin": "*",
      });
    }

    let get = this.http.get(url, {
      headers: headers,
    });

    return get.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          alert("Timeout! Login again to continue.");
          this.logoutService.logout();
        }
        return [];
      })
    );
  }

  public getHeaders(): HttpHeaders {
    var headers = new HttpHeaders({});

    if (localStorage.getItem("acc_tok")) {
      headers = new HttpHeaders({
        "X-access-token": localStorage.getItem("acc_tok"),
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      });
    }

    return headers;
  }
}
